export const SPORTS_WIDGET_TARGET_CLASS = 'sports-widget';
export const FIRST_ELEMENT_KEY = 0;
export const POST_URL = '/sportsbook-req/getSportsWidgetEventsAjax';
export const WIDGET_LABEL = 'Featured Homepage';
export const WIDGET_GTM_SUFFIX = '-widget';
export const WIDGET_GTM_FOOTER = 'see-all';
export const COLUMN_HEADERS = 'column-headers';
export const THREE_MARKET_COLUMN_HEADERS = 'three-market-headers';
